import { useTranslation } from "react-i18next";
import type { SelectOption } from "@/constants/company-form-options";

export interface UseLegalFormOptionsReturn {
  options: SelectOption[];
  getLabel: (value: string) => string | undefined;
}

/**
 * Hook to get legal form options with translated labels
 * Uses onboarding:step2.legalForm.options.* namespace
 */
export function useLegalFormOptions(): UseLegalFormOptionsReturn {
  const { t } = useTranslation(["onboarding"]);

  const options: SelectOption[] = [
    { value: "", label: t("onboarding:step2.legalForm.placeholder") },
    {
      value: "sp_z_oo",
      label: t("onboarding:step2.legalForm.options.sp_z_oo"),
    },
    { value: "sa", label: t("onboarding:step2.legalForm.options.sa") },
    { value: "sc", label: t("onboarding:step2.legalForm.options.sc") },
    { value: "jdg", label: t("onboarding:step2.legalForm.options.jdg") },
    { value: "sp_jawna", label: t("onboarding:step2.legalForm.options.sp_jawna") },
    { value: "sp_komandytowa", label: t("onboarding:step2.legalForm.options.sp_komandytowa") },
    { value: "sp_partnerska", label: t("onboarding:step2.legalForm.options.sp_partnerska") },
    { value: "fundacja", label: t("onboarding:step2.legalForm.options.fundacja") },
    { value: "stowarzyszenie", label: t("onboarding:step2.legalForm.options.stowarzyszenie") },
    { value: "spoldzielnia", label: t("onboarding:step2.legalForm.options.spoldzielnia") },
    { value: "other", label: t("onboarding:step2.legalForm.options.other") },
  ];

  const getLabel = (value: string): string | undefined => {
    const option = options.find((o) => o.value === value);
    return option?.label;
  };

  return { options, getLabel };
}
